import React, { useState } from "react";
import "./datatable.scss";
import CreditIssued from "./CreditIssued";
import CreditConsumed from "./CreditConsumed";
import { useCreditDashBoard_Csv } from '../../../../hooks/Refund/useCreditDashBoard_Csv';
import { toast } from 'react-toastify'; // Assuming you use react-toastify for notifications

const DataTable = ({ startDate, endDate }) => {
  const [activeTab, setActiveTab] = useState("home-tab");
  const { exportToCSV, isExporting, exportError } = useCreditDashBoard_Csv();

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleExportClick = async () => {
    try {
      // Determine which tab is active and export the corresponding data
      const tabType = activeTab === "home-tab" ? 'issued' : 'consumed';

      // toast.info(`Preparing ${tabType} transactions CSV...`);

      await exportToCSV(tabType, startDate, endDate);

      // Show success message
      // toast.success(`${tabType.charAt(0).toUpperCase() + tabType.slice(1)} transactions exported successfully!`);
    } catch (error) {
      toast.error(exportError || 'Failed to export CSV. Please try again.');
      console.error('CSV export error:', error);
    }
  };

  return (
    <>
      <section className="datatable">
        <div className="main-heading d-flex justify-content-between align-items-center">
          <ul className="nav nav-tabs viewdetail-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "home-tab" ? "active" : ""}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home-tab-pane"
                type="button"
                role="tab"
                aria-controls="home-tab-pane"
                aria-selected={activeTab === "home-tab"}
                onClick={() => handleTabClick("home-tab")}
              >
                Credits issued
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "profile-tab" ? "active" : ""}`}
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile-tab-pane"
                type="button"
                role="tab"
                aria-controls="profile-tab-pane"
                aria-selected={activeTab === "profile-tab"}
                onClick={() => handleTabClick("profile-tab")}
              >
                Credits consumed
              </button>
            </li>
          </ul>
          <div className="upperbtn">
            <button
              className="downloadcsvcustombutton"
              onClick={handleExportClick}
              disabled={isExporting}
            >
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 7.33301V11.333L7.33333 9.99967" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.99984 11.3333L4.6665 10" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66634V9.99967C14.6668 13.333 13.3335 14.6663 10.0002 14.6663H6.00016C2.66683 14.6663 1.3335 13.333 1.3335 9.99967V5.99967C1.3335 2.66634 2.66683 1.33301 6.00016 1.33301H9.3335" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66634H12.0002C10.0002 6.66634 9.3335 5.99967 9.3335 3.99967V1.33301L14.6668 6.66634Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              {isExporting ? 'Exporting...' : activeTab === "home-tab" ? 'Download Issued Csv' : 'Download Consumed Csv'}
            </button>
          </div>
        </div>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex="0"
          >
            <CreditIssued startDate={startDate} endDate={endDate} />
          </div>
          <div
            className="tab-pane fade"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex="0"
          >
            <CreditConsumed startDate={startDate} endDate={endDate} />
          </div>
        </div>
      </section>
    </>
  );
};

export default DataTable;